import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MaterialModule} from '../material/material.module';
import { AmplifyAuthenticatorModule } from '@aws-amplify/ui-angular';
import {UntypedFormBuilder, FormsModule, ReactiveFormsModule} from "@angular/forms";

import { PublicFormComponent } from './components/public-form/public-form.component';
import { ClientFormComponent } from './components/client-form/client-form.component';
import { ControlComponent } from '../form/form-controls/control/control.component';
import { DynamicFormComponent } from '../form/form-controls/dynamic-form/dynamic-form.component';
import { CoreModule } from 'src/core/core.module';



@NgModule({
  declarations: [
    PublicFormComponent,
    ClientFormComponent,
    ControlComponent,
    DynamicFormComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    AmplifyAuthenticatorModule,
    FormsModule,
    ReactiveFormsModule,
    CoreModule
  ],
  providers: [
    UntypedFormBuilder
  ]
})
export class FormModule { }
